import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: {
        display: 'flex',
        maxWidth: '100vw',
        overflowX: 'hidden',
        background: 'white'
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        width: `calc(100vw - 240px)`,
        minHeight: '100vh',
        [theme.breakpoints.down('sm')]: {
            padding: '18px 0px 18px 0px'
        }
    },
    contentShift: {
        width: `calc(100vw - ${240 + theme.spacing(1)}px)`,
        '@media (max-width: 960px)': {
            width: `calc(100vw)`
        },
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    fakeToolbar: {
        ...theme.mixins.toolbar
    },
    link: {
        '&:not(:first-child)': {
            paddingLeft: 15
        }
    },
    container: {
        marginTop: '15px',
        marginBottom: '75px'
    }
}));
